<app-nav-menu></app-nav-menu>
<div class="container-fluid" style="height: 87%;">
  <router-outlet></router-outlet>
</div>

